import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _Chevron;
const _excluded = ["children", "active", "as"];
import React, { forwardRef, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from '@resultadosdigitais/tangram-react-icons';
import styled, { css } from 'styled-components';
import Badge from '../Badge';
import Dropdown from '../Dropdown';
import { useBoundary } from '../Boundary';
import { useMergeRefs } from '../hooks';
const DISPLAY_NAME = 'NavbarItem';
const Chevron = styled(props => {
  return /*#__PURE__*/React.createElement(ChevronDown, _extends({}, props, {
    size: ChevronDown.sizes.xs,
    title: "Chevron down",
    "aria-hidden": "true"
  }));
}).withConfig({
  displayName: "NavbarItem__Chevron",
  componentId: "sc-e4d3ha-0"
})(["display:inline-block;margin-left:var(--size-spacing-01);fill:var(--neutral-icon-low-emphasis);"]);
const Root = styled.button.withConfig({
  displayName: "NavbarItem__Root",
  componentId: "sc-e4d3ha-1"
})(["position:relative;display:flex;flex-shrink:0;align-items:center;align-self:stretch;border:0;padding-right:var(--size-spacing-03);padding-left:var(--size-spacing-03);color:var(--neutral-text-high-emphasis);text-decoration:none;font:var(--text-md-bold);background:transparent;> svg:not(", "),> ", " > svg{fill:var(--neutral-icon-low-emphasis);}&:disabled{color:var(--neutral-text-disabled);> svg,> ", ",> ", " > svg{fill:var(--neutral-icon-disabled);}}&:hover:not(:disabled),&:focus:not(:disabled){cursor:pointer;outline:none;color:var(--primary-text);text-decoration:none;> svg:not(", "),> ", " > svg{fill:var(--primary-icon);}}", " ", " > ", "{align-items:center;> ", "{position:relative;transform:none;}> svg + ", "{position:absolute;transform:translate(0,-50%);}}"], Chevron, Badge.WrapperStyle, Chevron, Badge.WrapperStyle, Chevron, Badge.WrapperStyle, _ref => {
  let {
    $isIcon
  } = _ref;
  return !$isIcon && css(["> *:not(", "){margin-left:var(--size-spacing-02);}"], Chevron);
}, _ref2 => {
  let {
    $active
  } = _ref2;
  return $active && css(["", " &:not(:disabled){color:var(--primary-text);> svg,> ", ",> ", " > svg{fill:var(--primary-icon);}&:after{background:var(--primary-border);}}"], _ref3 => {
    let {
      $isIcon
    } = _ref3;
    return !$isIcon && css(["&:after{content:'';display:block;position:absolute;bottom:0;left:0;width:100%;height:2px;background:var(--neutral-border-interactive-disabled);}"]);
  }, Chevron, Badge.WrapperStyle);
}, Badge.WrapperStyle, Badge.Style, Badge.Style);
const NavbarItem = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
      children,
      active,
      as
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded);
  const {
    isInsideBoundary
  } = useBoundary();
  const isInsideDropdownAnchor = isInsideBoundary(Dropdown.Anchor.displayName);
  const finalAs = as || (rest.href && !isInsideDropdownAnchor ? 'a' : 'button');
  const elementRef = useRef(null);
  const mergedRef = useMergeRefs([ref, elementRef]);
  const [isIcon, setIsIcon] = useState(false);
  useEffect(() => {
    if (!elementRef.current) return;
    const icon = elementRef.current.querySelector(":scope > svg:not(".concat(Chevron, ")")) || elementRef.current.querySelector(":scope > ".concat(Badge.WrapperStyle, " > svg"));
    setIsIcon(!!icon);
  }, []);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    as: finalAs,
    $active: active,
    $isIcon: isIcon,
    ref: mergedRef
  }), children, isInsideDropdownAnchor && !isIcon && (_Chevron || (_Chevron = /*#__PURE__*/React.createElement(Chevron, null))));
});
NavbarItem.displayName = DISPLAY_NAME;
NavbarItem.Style = Root;
process.env.NODE_ENV !== "production" ? NavbarItem.propTypes = {
  /**
   * Sets the item as active.
   */
  active: PropTypes.bool,
  /**
   * Set element type to be rendered for this component.
   * Additional properties can be passed to the component according to the element specified in this property.
   * @example
   * // with react-router-dom
   * <Navbar.Item as={Link} to="/dashboard">Dashboard</Navbar.Item>
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  /**
   * Sets children.
   */
  children: PropTypes.node
} : void 0;
export default NavbarItem;